var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfSectionCivil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.931 16.075 4.57 2.768a1.103 1.103 0 0 0 1.642-1.19l-1.214-5.196 4.046-3.506a1.102 1.102 0 0 0-.627-1.928l-5.323-.452-2.078-4.91a1.11 1.11 0 0 0-2.031 0L6.837 6.563l-5.322.452a1.095 1.095 0 0 0-.627 1.928l4.046 3.498-1.214 5.196a1.095 1.095 0 0 0 1.642 1.19l4.57-2.752Z",
    fill: "#68686A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfSectionCivil);
export default __webpack_public_path__ + "static/media/pdfSectionCivil.484f0866e5b43e734007677162d36115.svg";
export { ForwardRef as ReactComponent };